import React from "react";
import {useTheme} from "@emotion/react";

import {PercentIcon} from "@pg-design/icons-module";
import {priceFormat} from "@pg-mono/string-utils";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {PropertyListIconButton} from "../PropertyListIconButton";

interface IProps {
    property: Pick<IPropertyDetail, "price">;
    onClick?: (event: React.MouseEvent) => void;
    showPrice?: boolean;
}

export function PromotionButton(props: IProps) {
    const {property} = props;

    const theme = useTheme();

    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();

        props.onClick?.(event);
    };

    const renderPriceInfo = () => {
        if (props.showPrice) {
            return (
                <>
                    <br />
                    <span data-testid="icon-button-price">{priceFormat(property.price as number)}</span>
                </>
            );
        }

        return null;
    };

    return (
        <PropertyListIconButton icon={<PercentIcon size="1.2" wrapperColor={theme.colors.info} wrapperSize="2" wrapperType="circle" />} onClick={onClick}>
            Promocja {renderPriceInfo()}
        </PropertyListIconButton>
    );
}
import React from "react";
import {useTheme} from "@emotion/react";

import {PercentIcon} from "@pg-design/icons-module";
import {priceFormat} from "@pg-mono/string-utils";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {PropertyListIconButton} from "../PropertyListIconButton";

interface IProps {
    property: Pick<IPropertyDetail, "price">;
    onClick?: (event: React.MouseEvent) => void;
    showPrice?: boolean;
}

export function PromotionButton(props: IProps) {
    const {property} = props;

    const theme = useTheme();

    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();

        props.onClick?.(event);
    };

    const renderPriceInfo = () => {
        if (props.showPrice) {
            return (
                <>
                    <br />
                    <span data-testid="icon-button-price">{priceFormat(property.price as number)}</span>
                </>
            );
        }

        return null;
    };

    return (
        <PropertyListIconButton icon={<PercentIcon size="1.2" wrapperColor={theme.colors.info} wrapperSize="2" wrapperType="circle" />} onClick={onClick}>
            Promocja {renderPriceInfo()}
        </PropertyListIconButton>
    );
}
